export default {
  "esgPlatform": {
    "esgDashboard": "Tableau de bord ESG",
    "esgPlatform": "Plateforme ESG",
    "myProtocol": "Mon Protocole",
    "esgProgress": "Progrès ESG",
    "common": {
      "myProducts": "Mes Produits",
      "esgCompliance": "Conformité ESG",
      "active": "Actif",
      "deactivated": "Désactivé"
    },
    "title": "Plateforme ESG",
    "esgCompliance": "Conformité ESG",
    "standards": "Normes",
    "addNewStandard": "Ajouter une nouvelle norme",
    "surveyType": "Type d'enquête",
    "addNewSurvey": "Ajouter une nouvelle enquête",
    "surveyDescription": "Description de l'enquête",
    "surveyDescriptionTT": "Entrez la description de l'enquête",
    "surveyInstructions": "Instructions de l'enquête",
    "surveyInstructionsTT": "Entrez les instructions pour l'enquête",
    "surveyScore": "Score de l'enquête",
    "surveyScoreTT": "Permettre de noter l'enquête",
    "whoWillAnswerThisSurvey": "Qui répondra à cette enquête ?",
    "whoWillAnswerThisSurveyTT": "Sélectionnez le type d'utilisateurs qui répondront à cette enquête",
    "typeOfTheSurvey": "Type de l'enquête",
    "standardTitle": "Titre de la norme",
    "standardTitleTT": "Entrez le titre de la norme",
    "shortCode": "Code court",
    "shortCodeTT": "Entrez le code court de la norme",
    "standardDescription": "Description de la norme",
    "standardDescriptionTT": "Entrez la description de la norme",
    "seal": "Sceau",
    "sealTT": "Sélectionnez le sceau de la norme",
    "status": "Statut",
    "upload": "Télécharger",
    "thisfieldIsRequired": "Ce champ est requis",
    "pleaseFillRequiredFields": "Veuillez remplir les champs requis",
    "standardAddedSuccessfully": "Norme ajoutée avec succès",
    "errorSubmittingForm": "Erreur lors de la soumission du formulaire",
    "createNewEsgStandard": "Créer une nouvelle norme ESG",
    "close": "Fermer",
    "settings": "Paramètres",
    "next": "Suivant",
    "keyIssuesAndGoals": "Sujets clés et objectifs",
    "keyIssuesAndGoalsTT": "Sujets clés et objectifs de la norme",
    "environmental": "Environnemental",
    "issues": "Sujets",
    "addIssue": "Ajouter un sujet",
    "social": "Social",
    "governance": "Gouvernance",
    "goals": "Objectifs",
    "target": "Cible (Années)",
    "questions": "Questions",
    "type": "Type",
    "mandatory": "Obligatoire",
    "addNewGoal": "Ajouter un nouvel objectif",
    "deleteIssueConfirmation": "Êtes-vous sûr de vouloir supprimer ce sujet ? La suppression de ce sujet entraînera également la suppression définitive de tous les objectifs et questions associés. Cette action est irréversible.",
    "deleteGoalConfirmation": "Êtes-vous sûr de vouloir supprimer cet objectif ? La suppression de cet objectif entraînera également la suppression définitive de toutes les questions associées. Cette action est irréversible.",
    "deleteConfirmation": "Êtes-vous sûr de vouloir supprimer ? Cette action est irréversible.",
    "standardSettings": "Paramètres de la norme",
    "standardStatus": "Statut de la norme",
    "active": "Actif",
    "inactive": "Inactif",
    "approvalMethod": "Méthode d'approbation",
    "approveManually": "Approuver manuellement",
    "scoreForApproval": "Score pour approbation",
    "overallProtocolScore": "Score global du protocole",
    "overallProtocolScoreTT": "Entrez le score global du protocole",
    "heading": "Rubrique",
    "selectHeadingTooltip": "Sélectionnez une rubrique pour la question de l'enquête",
    "survey": "Enquête",
    "goalTitle": "Titre de l'objectif",
    "goalTitleTT": "Entrez le titre de l'objectif",
    "goalTargetYear": "Année cible de l'objectif",
    "environmetalScore": "Score environnemental",
    "environmetalScoreTT": "Entrez le score environnemental",
    "socialScore": "Score social",
    "socialScoreTT": "Entrez le score social",
    "governanceScore": "Score de gouvernance",
    "governanceScoreTT": "Entrez le score de gouvernance",
    "mandatoryApproval": "Approbation obligatoire",
    "preview": "Aperçu",
    "pleaseAddAtLeastOneIssueAndGoal": "Veuillez ajouter au moins un sujet avec au moins un objectif avant de passer à l'aperçu.",
    "noContentToPreview": "Il n'y a pas de contenu à prévisualiser. Veuillez ajouter au moins un sujet et un objectif.",
    "standardPreview": "Aperçu de la norme",
    "saveStandard": "Enregistrer la norme",
    "standardSavedSuccessfully": "Norme enregistrée avec succès !",
    "standardDeletedSuccessfully": "Norme supprimée avec succès !",
    "protocolDeletedSuccessfully": "Protocole supprimé avec succès !",
    "standardUpdatedSuccessfully": "Norme mise à jour avec succès !",
    "pleaseEnterWholeNumberBetween0and100": "Veuillez entrer un pourcentage entre 0 et 100",
    "issueCreatedSuccessfully": "Sujet créé avec succès",
    "errorCreatingIssue": "Erreur lors de la création du sujet. Veuillez réessayer.",
    "issueTitleUpdatedSuccessfully": "Titre du sujet mis à jour avec succès",
    "errorUpdatingIssueTitle": "Erreur lors de la mise à jour du titre du sujet. Veuillez réessayer.",
    "issueDeletedSuccessfully": "Sujet supprimé avec succès",
    "errorDeletingIssue": "Erreur lors de la suppression du sujet. Veuillez réessayer.",
    "goalCreatedSuccessfully": "Objectif créé avec succès",
    "errorCreatingGoal": "Erreur lors de la création de l'objectif. Veuillez réessayer.",
    "goalUpdatedSuccessfully": "Objectif mis à jour avec succès",
    "errorUpdatingGoal": "Erreur lors de la mise à jour du titre de l'objectif. Veuillez réessayer.",
    "errorDeletingGoal": "Erreur lors de la suppression de l'objectif. Veuillez réessayer.",
    "goalDeletedSuccessfully": "Objectif supprimé avec succès",
    "standardActivatedSuccessfully": "Norme activée avec succès",
    "goalTitleRequired": "Le titre de l'objectif est requis",
    "questionsRequired": "Les questions sont requises",
    "noSurveyAvailable": "Aucune enquête disponible",
    "myProducts": {
      "addNewProduct": "Ajouter un nouveau produit",
      "lastUpdated": "Dernière mise à jour",
      "addedBy": "Ajouté par"
    },
    "dashboard": {
      "subEnterprises": "Sous-Entreprises",
      "registerSubEnterprise": "Enregistrer une sous-entreprise",
      "exportAsCSV": "Exporter en CSV",
      "enterprise": "Entreprise",
      "licenseID": "ID de licence",
      "membershipPlan": "Plan d'adhésion",
      "activationKeys": "Clés d'activation",
      "users": "Utilisateurs",
      "registrationDate": "Date d'enregistrement",
      "country": "Pays",
      "status": "Statut",
      "countryPlaceholder": "Sélectionner un pays",
      "enterpriseName": "Nom de l'entreprise",
      "enterpriseNamePlaceholder": "Entrer le nom de l'entreprise",
      "enterpriseEmail": "Email de l'entreprise",
      "enterpriseEmailPlaceholder": "Entrer l'adresse email",
      "enterprisePhoneNumber": "Numéro de téléphone de l'entreprise",
      "enterprisePhoneNumberPlaceholder": "Entrer le numéro de téléphone",
      "provincePlaceholder": "Entrer la province/l'état",
      "regionPlaceholder": "Entrer la région/le district",
      "villagePlaceholder": "Entrer le village/la ville",
      "address": "Adresse",
      "province": "Province/État",
      "region": "Région/District",
      "village": "Village/Ville",
      "addressPlaceholder": "Entrer l'adresse",
      "dateOfRegistration": "Date d'enregistrement",
      "dateOfRegistrationPlaceholder": "Sélectionner la date d'enregistrement",
      "subscriptionUpTo": "Abonnement jusqu'à",
      "subscriptionUpToPlaceholder": "Sélectionner la date de fin d'abonnement",
      "products": "Produits",
      "initialAssessmentReport": "Rapport d'évaluation initial",
      "enterHere": "Entrer ici",
      "attachInitialAssessmentReport": "Joindre le rapport d'évaluation initial",
      "linkWithProducts": "Lier avec les produits",
      "linkWithProductsPlaceholder": "Sélectionner les produits liés",
      "uploadLogo": "Télécharger le logo",
      "uploadLogoPlaceholder": "Télécharger le logo de l'entreprise",
      "licenseIDPlaceholder": "Entrer l'ID de licence",
      "deactivateAccount": "Désactiver le compte",
      "activateAccount": "Activer le compte",
      "deactivateMsg": "Êtes-vous sûr de vouloir désactiver ce compte ?",
      "activateMsg": "Êtes-vous sûr de vouloir activer ce compte ?",
      "deleteAccount": "Supprimer le compte",
      "deleteMsg": "Êtes-vous sûr de vouloir supprimer ce compte ?"
    },
    "activate": "Activer",
    "confirmation": "Confirmation",
    "standardDeleteConfirmation": "Êtes-vous sûr de vouloir supprimer cette norme ?",
    "protocolDeleteConfirmation": "Êtes-vous sûr de vouloir supprimer ce protocole ?",
    "surveyQuestionForTheGoal": "Question d'enquête pour l'objectif",
    "selectExistingESGSurveyOrCreateNew": "Sélectionner une enquête ESG existante ou en créer une nouvelle",
    "surveyBuilder": "Constructeur d'enquête ESG",
    "surveyDetails": "Détails de l'enquête",
    "createnewSurvey": "Créer une nouvelle enquête",
    "startContinueSurvey": "Démarrer/Continuer l'enquête",
    "surveyOverview": "Aperçu de l'enquête",
    "surveyTitle": "Titre de l'enquête",
    "surveyTitleTT": "Entrez le titre de l'enquête",
    "surveyCompletionPercentage": "Pourcentage d'achèvement de l'enquête",
    "inProgress": "En cours",
    "surveyProgress": "Progression de l'enquête",
    "howToCompleteSurvey": "Comment compléter l'enquête",
    "confirmSurveyResponse": "Vous êtes sur le point de soumettre votre réponse. Veuillez confirmer si vous souhaitez continuer.",
    "progress": {
      "progress": "Progression",
      "dashboard": "Tableau de bord",
      "esgProgress": "Progrès ESG",
      "companyName": "Nom de l'entreprise",
      "search": "Rechercher",
      "select": "Sélectionner",
      "country": "Pays",
      "standard": "Norme",
      "subOrganization": "Sous-organisation",
      "protocols": "Protocoles",
      "actions": "Actions",
      "subOrganizations": "Sous-organisations",
      "downloadReport": "Télécharger le rapport",
      "comparison": "Comparaison",
      "messages": "Messages",
      "validateData": "Valider les données",
      "recommendations": "Recommandations",
      "ESRSIssueAndGoals": "Sujets et objectifs ESRS",
      "protocolProgress": "Progression du protocole"
    },
    "validation": {
      "dataValidations": "Validations des données",
      "validateData": "Valider les données",
      "inputData": "Données d'entrée",
      "question": "Question",
      "issueAndGoal": "Sujet et objectif",
      "environmental": "Environnemental",
      "social": "Social",
      "governance": "Gouvernance",
      "search": "Rechercher",
      "rejectionSuccess": "Raison du rejet soumise avec succès.",
      "rejectionFailed": "Échec de la soumission de la raison du rejet. Veuillez réessayer."
    },
    "startNewEsgProtocol": "Démarrer un nouveau protocole ESG",
    "getStartedWithEsg": "Commencer avec l'ESG",
    "getStartedEsgMsg": "Aucun protocole n'a encore été ajouté. Ajoutez un protocole pour commencer votre parcours vers une gestion et un reporting ESG efficaces.",
    "startEsgProtocol": "Démarrer le protocole ESG",
    "createNewProtocolWithoutStandard": "Créer un nouveau protocole sans norme",
    "selectEsgStandard": "Sélectionner la norme ESG",
    "addNewProtocol": "Ajouter un nouveau protocole",
    "protocolTitle": "Titre du protocole",
    "subOrganization": "Sous-organisations",
    "protocolAddedMsg": "Protocole ajouté avec succès.",
    "existingProtocols": "Protocoles existants",
    "protocolSettings": "Paramètres du protocole",
    "protocolSettingsUpdated": "Paramètres du protocole mis à jour avec succès.",
    "failedToUploadFile": "Échec du téléchargement de l'image. Veuillez réessayer.",
    "failedToUploadFileToS3": "Échec du téléchargement de l'image vers S3",
    "selectSubOrg": "Sélectionner les sous-organisations",
    "selectSubOrgMsg": "Sélectionnez la sous-organisation pour laquelle vous définissez des objectifs et des buts liés aux protocoles ESG (Environnemental, Social et Gouvernance). Cette option vous permet de spécifier quelle partie de votre organisation est responsable de la mise en œuvre et du suivi de ces objectifs. En attribuant des objectifs à des sous-organisations individuelles, vous pouvez adapter les initiatives ESG pour répondre aux besoins opérationnels et aux impacts spécifiques, garantissant une approche ciblée de la durabilité et de la gouvernance à différents niveaux organisationnels.",
    "selectedSubOrg": "Sous-organisations sélectionnées",
    "subOrgs": "Sous-organisations",
    "activityLog": "Journal d'activité",
    "activityLogFor": "Journal d'activité pour",
    "activityLogDesc": "Suivez toutes les modifications apportées aux objectifs, questions et sujets ESG, y compris les ajouts, les modifications et les suppressions, avec les détails sur l'utilisateur, l'action et l'horodatage",
    "protocolActivatedSuccessfully": "Protocole activé avec succès",
    "activationKey": "Clé d'activation",
    "userNameAndId": "Nom d'utilisateur et ID",
    "email": "Email",
    "userRole": "Rôle de l'utilisateur",
    "userRegistrationDate": "Date d'enregistrement de l'utilisateur",
    "protocolUpdatedSuccessfully": "Protocole mis à jour avec succès.",
    "createNewProtocol": "Créer un nouveau protocole",
    "myProtocols": "Mes protocoles",
    "viewDetails": "Voir les détails",
    "viewProgressByGoal": "Voir la progression par objectif",
    "downloadReport": "Télécharger le rapport",
    "chooseTimeFrame": "Choisissez la période pour le rapport que vous souhaitez télécharger.",
    "downloading": "Téléchargement",
    "downloadingDesc": "Votre rapport de protocole ESG est en cours de préparation pour le téléchargement. Veuillez patienter pendant que nous générons le fichier.",
    "updateStatus": "Mettre à jour le statut",
    "updateStatusDesc": "Veuillez sélectionner le nouveau statut pour le Protocole Abrafrutas/Producteurs de fruits pour la sous-organisation AGRICULTURA DO VALE LTDA - AGRIVALE.",
    "validationConfirm": "Confirmation",
    "validationConfirmMsg": "Êtes-vous sûr de vouloir rejeter cette réponse ? L'utilisateur devra soumettre à nouveau la réponse. Cette action est irréversible.",
    "validationRejectionReason": "Raison du rejet",
    "validationRejectionReasonPlaceholder": "Écrire ici",
    "inputData": "Données d'entrée",
    "question": "Question",
    "issueGoal": "Sujet et objectif",
    "surveyResponseText": "Réponse à l'enquête",
    "goal": "Objectif",
    "submittedBy": "Soumis par",
    "dateSubmitted": "Date de soumission",
    "responses": "Réponses",
    "uploadedDocument": "Document téléchargé",
    "noFilesUploaded": "Aucun fichier téléchargé",
    "getData": "Obtenir les données",
    "recommendations": "Recommandations",
    "actionPlan": "Plan d'action",
    "subOrganizations": "Sous-organisations",
    "farms": "Fermes",
    "farmers": "Agriculteurs",
    "totalGoals": "Objectifs totaux",
    "startDate": "Date de début",
    "deadline": "Date limite",
    "standard": "Norme",
    "goalsProgress": "Progression des objectifs",
    "esrsProgress": "Progression ESRS",
    "esrsProtocol": "Protocole ESRS",
    "surveyResponse": {
      "enterYourAnswer": "Entrez votre réponse",
      "fieldRequired": "Ce champ est requis",
      "additionalQuestions": "Questions supplémentaires",
      "previous": "PRÉCÉDENT",
      "skip": "PASSER",
      "submit": "SOUMETTRE",
      "next": "SUIVANT",
      "step": "Étape",
      "of": "de",
      "question": "Question",
      "errorLoadingStandard": "Erreur lors du chargement de la norme",
      "errorLoadingQuestions": "Erreur lors du chargement des questions",
      "errorSubmittingSurvey": "Erreur lors de la soumission de l'enquête",
      "surveySubmittedSuccess": "Enquête soumise avec succès",
      "loadingGoalTitle": "Chargement du titre de l'objectif...",
      "questionOf": "Question {current} sur {total}",
      "ratingScale": {
        "title": "Utilisez l'échelle de notation",
        "description": "Pour les questions qui utilisent une échelle de notation (par exemple, de 1 à 5), veuillez considérer ce qui suit :",
        "stronglyDisagree": "1 = Fortement en désaccord",
        "disagree": "2 = En désaccord",
        "neutral": "3 = Neutre",
        "agree": "4 = D'accord",
        "stronglyAgree": "5 = Fortement d'accord",
        "chooseNumber": "Choisissez le nombre qui reflète le mieux votre opinion."
      },
      "instructions": {
        "readCarefully": "Lisez attentivement chaque question",
        "readDescription": "Prenez le temps de comprendre chaque question avant de sélectionner votre réponse. L'enquête comprend un mélange de questions à choix multiples, d'échelle de notation et de questions ouvertes.",
        "beHonest": "Soyez honnête et transparent",
        "beHonestDescription": "Vos réponses nous aideront à évaluer nos pratiques actuelles et à identifier les domaines à améliorer. Veuillez fournir des commentaires honnêtes basés sur vos expériences.",
        "provideExamples": "Fournissez des exemples spécifiques",
        "provideExamplesDescription": "Dans les questions ouvertes, n'hésitez pas à inclure des exemples ou des suggestions spécifiques. Vos commentaires détaillés seront inestimables pour l'élaboration de nos initiatives ESG.",
        "reviewResponses": "Revoyez vos réponses",
        "reviewResponsesDescription": "Avant de soumettre l'enquête, prenez un moment pour revoir vos réponses. Assurez-vous que vous êtes satisfait de vos réponses et que toutes les questions ont été traitées.",
        "submitSurvey": "Soumettez l'enquête",
        "submitSurveyDescription": "Une fois que vous êtes confiant dans vos réponses, cliquez sur le bouton 'Soumettre' à la fin de l'enquête. Votre participation est grandement appréciée !",
        "contactSupport": "Contactez-nous pour obtenir de l'aide",
        "contactSupportDescription": "Si vous rencontrez des problèmes ou avez des questions lors de l'enquête, veuillez contacter notre équipe de support à [email de support] ou [numéro de téléphone de support]."
      },
      "actionPlans": "Plans d'action",
      "uploadEvidence": "Télécharger la preuve",
      "fileUploadSuccess": "Fichier téléchargé avec succès",
      "fileUploadError": "Erreur lors du téléchargement du fichier",
      "selectMeasurementUnit": "Sélectionnez l'unité de mesure",
      "selectFile": "Sélectionnez le fichier pour télécharger les données",
      "dragDrop": "ou glissez-déposez ici",
      "recommendations": "Recommandations",
      "signatureRequired": "La signature est requise",
      "waitForFileUpload": "Veuillez attendre le téléchargement du fichier",
      "fileRequired": "Le fichier est requis",
      "getDataQuestions": "Obtenir les questions de données"
    },
    "validateData": "Valider les données",
    "messages": "Messages",
    "comparision": "Comparaison",
    "download": "Télécharger",
    "issueAndGoal": "Sujet et objectif",
    "reasonForRejection": "Raison du rejet",
    "listOfUsers": "Liste des utilisateurs",
    "totalUsers": "Total des utilisateurs",
    "viewQuestionsRecommendations": "Voir les recommandations de questions",
    "protocolDetails": "Détails du protocole"
  }
}